import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ApiDataService } from '../../services/api.service';

@Component({
    selector: 'app-forgot-password',
    imports: [FormsModule],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  userEmail: string = '';
  success: boolean = false;

  constructor(
    private router: Router,
    private _apiService: ApiDataService
  ){}
  
  changePassword(){
    const PAYLOAD = {
      email: this.userEmail
    };
    this._apiService.forgotPassword(PAYLOAD).subscribe(x => {
      if(x.status === 'success'){
        this.success = true;
      }
      else{
        alert(x.status);
      } 
    }, (error) => {
      alert(error.error.error);
    }, () => {
      
    });
  }
}
